import type { DeviceContext } from '@/api/auth'

export function shouldShowBanner(
  deviceContext: DeviceContext | null,
  dismissed: boolean,
): boolean {
  if (!deviceContext) return false
  if (deviceContext.isRegistered) return false
  return !dismissed
}
